<template lang="pug">
iframe(:src='`https://rt.seatcoversolutions.com/?p=${props.params.pl}`' class='w-full h-[900px]')
</template>
<script setup lang="ts">
const props = defineProps<{
  params: any
}>()
</script>
